// extracted by mini-css-extract-plugin
export default {"button":"AddTaskButton_button__KBpGF","btnHover":"AddTaskButton_btnHover__LsUc5"};